import React, { useState } from "react";
import { useEffect } from "react";
import {
  CheckEmployeePermissions,
  FetchEmployeePermissions,
} from "../../services/apiService";
import {
  CheckIcon,
  FileText,
  Hash,
  ListCheck,
  Route,
  ShieldBan,
  ShieldCheckIcon,
  ShieldEllipsis,
  X,
} from "lucide-react";
import { showErrorToast } from "../../utils/toastUtils";

function CheckPermissions() {
  const [userData, setUserData] = useState(null);
  const [routeData, setRouteData] = useState(null);
  const [inputError, setInputError] = useState(null);
  const [url, setUrl] = useState(null);

  const checkPermissions = async () => {
    setInputError("");
    if (!url) {
      return setInputError("⚠ This field cannot be empty");
    }

    setInputError(null);
    try {
      const res = await CheckEmployeePermissions(url);

      if (res) {
        setUserData(res);
        console.log(res);
      }

      if (res?.data?.status?.code === 422) {
        showErrorToast(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllRoutes = async () => {
    try {
      const res = await FetchEmployeePermissions();

      if (res) {
        setRouteData(res);
        console.log(res);
      }

      if (res?.data?.status?.code === 422) {
        showErrorToast(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRoutesClick = async (routePath) => {
    if (!routePath) return;
    setUrl(routePath);

    if (url === routePath) {
      await checkPermissions();
    }
  };

  useEffect(() => {
    fetchAllRoutes();
  }, []);

  return (
    <>
      <div className="w-full min-h-screen bg-white text-black ">
        <div className="mt-10 flex flex-col justify-center gap-4 bg-blue-50  p-8 rounded-xl">
          <div className="w-full flex justify-center text-4xl items-center gap-4 font-bold text-blue-800">
            <ShieldCheckIcon size={40} /> Check Permissions
          </div>

          <div className="flex flex-col justify-start items-center gap-4 ">
            <label htmlFor="userId" className="text-xl font-semibold">
              {" "}
              Enter Url:
            </label>

            <div className="flex bg-white border border-blue-800 h-[50px] rounded-xl px-4">
              <input
                type="text"
                placeholder="Eg: admin-dashboard"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                autoFocus
                name=""
                id=""
                className="border-none tracking-wider outline-none "
              />
            </div>

            {inputError && (
              <div className="text-red-600 text-xl font-semibold">
                {inputError}
              </div>
            )}

            <button
              id="check-permission-button"
              onClick={checkPermissions}
              type="button"
              className="bg-blue-600 text-white rounded-xl p-3"
            >
              Check
            </button>
          </div>
        </div>

        {userData && (
          <div>
            {userData?.data?.permission === "granted" ? (
              <div className="flex justify-center mt-6">
                <div className="bg-white rounded-2xl shadow-lg px-6 py-5 w-full max-w-md border border-gray-100">
                  <p className="bg-blue-800 text-white flex items-center justify-between my-5 px-4 rounded-lg py-2 text-2xl font-bold">
                    For-{" "}
                    <span className="bg-white text-gray-800 px-2 rounded-md py-1 ">
                      {url}
                    </span>
                  </p>

                  <div className="flex items-center gap-3 mb-3">
                    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-100">
                      <CheckIcon className="text-blue-600 w-6 h-6 animate-bounce" />
                    </div>

                    <h3 className="text-lg font-semibold text-gray-800">
                      Permission Status
                    </h3>
                  </div>

                  <div className="flex items-center justify-between mt-4">
                    <span className="text-sm text-gray-500">Access</span>

                    <span
                      className="px-4 py-1 rounded-full text-sm font-medium 
                         bg-blue-50 text-blue-700 border border-blue-200"
                    >
                      {userData?.data?.permission}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-full items-center justify-center py-4">
                <div className="flex items-center justify-center gap-3 text-red-800 bg-red-50 p-4 rounded-md">
                  <X />

                  {userData.message ||
                    userData.status?.message ||
                    userData.data?.message}
                </div>
              </div>
            )}
          </div>
        )}

        {routeData && (
          <div className="flex flex-col gap-8 mt-6 py-10 px-4">
            {/* Header */}
            <div className="flex justify-center items-center gap-3 text-4xl font-bold text-blue-700">
              <ListCheck className="w-10 h-10" />
              All Routes
            </div>

            {/* Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {routeData.data?.permissions?.map((item, index) => (
                <div
                  key={index}
                  onClick={() => handleRoutesClick(item.route_path)}
                  className="group relative bg-white rounded-2xl border border-gray-100 
                     shadow-md hover:shadow-2xl transition-all duration-300 
                     hover:-translate-y-1 p-5"
                >
                  {/* Top Badge */}
                  {/* <div className="absolute top-4 right-4">
                    <span
                      className={`px-3 py-1 text-xs font-semibold rounded-full
                ${
                  item.status === 1
                    ? "bg-emerald-100 text-emerald-700"
                    : "bg-red-100 text-red-700"
                }`}
                    >
                      {item.status === 1 ? "active" : "not active"}
                    </span>
                  </div> */}

                  {/* Card Content */}
                  <div className="flex flex-col gap-4">
                    <div className="flex items-center gap-3">
                      <Hash className="w-5 h-5 text-gray-400 group-hover:text-emerald-600 transition" />
                      <p className="text-sm text-gray-600">
                        ID
                        <span className="ml-2 font-semibold text-gray-900">
                          {item.id}
                        </span>
                      </p>
                    </div>

                    <div className="flex items-center gap-3">
                      <FileText className="w-5 h-5 text-gray-400 group-hover:text-emerald-600 transition" />
                      <p className="text-sm text-gray-600">
                        Route Name
                        <span className="ml-2 font-semibold text-gray-900">
                          {item.route_name}
                        </span>
                      </p>
                    </div>

                    <div className="flex items-center gap-3">
                      <Route className="w-5 h-5 text-gray-400 group-hover:text-emerald-600 transition" />
                      <p className="text-sm text-gray-600 break-all">
                        Route Path
                        <span className="ml-2 font-semibold text-gray-900">
                          {item.route_path}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default CheckPermissions;
